export default class IosBridge {
  constructor(iosBridge) {
    this.iosBridge = iosBridge;
  }

  async printText(base64Text, printerType, printerValue) {
    try {
      return await this.iosBridge.postMessage({
        action: "printText",
        base64Text: base64Text,
        printerType: printerType,
        printerValue: printerValue,
      });
    } catch (error) {
      console.error("printText via iOS Bridge failed:", error);
      return "ERROR";
    }
  }

  async getLocalIp() {
    try {
      return await this.iosBridge.postMessage({
        action: "getLocalIp",
      });
    } catch (error) {
      console.error("getLocalIp via iOS Bridge failed:", error);
      return "127.0.0.1";
    }
  }

  onApiResponse(responseJson) {
    try {
      this.iosBridge.postMessage({
        action: "onApiResponse",
        responseJson: responseJson,
      });
    } catch (error) {
      console.error("onApiResponse via iOS Bridge failed:", error);
    }
  }
}
